<template>
  <el-dialog
    :title="$t(`header.resetPassword`)"
    :visible.sync="dialogVisible"
    :before-close="cancel"
    :close-on-click-modal="false"
    width="560px">
    <el-form :model="passwordForm" :rules="rules" ref="passwordForm" class="update-password">
      <el-form-item :label="$t(`header.oldPassword`)" prop="password" label-width="80px">
        <el-input :type="visible1 ? 'text' : 'password'" v-model.trim="passwordForm.password" :placeholder="$t(`header.old`)" auto-complete="off">
        </el-input>
        <img @click="visible1 = !visible1" v-show="!visible1" class="eyes-image" src="@/assets/images/login/show.png" alt="">
        <img @click="visible1 = !visible1" v-show="visible1" class="eyes-image" src="@/assets/images/login/hidden.png" alt="">
      </el-form-item>
      <el-form-item :label="$t(`header.newPassword`)" prop="newPassword" label-width="80px">
        <el-input :type="visible2 ? 'text' : 'password'" v-model.trim="passwordForm.newPassword" :placeholder="$t(`header.new`)" auto-complete="off">
        </el-input>
        <img @click="visible2 = !visible2" v-show="!visible2" class="eyes-image" src="@/assets/images/login/show.png" alt="">
        <img @click="visible2 = !visible2" v-show="visible2" class="eyes-image" src="@/assets/images/login/hidden.png" alt="">
      </el-form-item>
      <el-form-item :label="$t(`header.confirmPassword`)" prop="confirmPassword" label-width="80px">
        <el-input :type="visible3 ? 'text' : 'password'" v-model.trim="passwordForm.confirmPassword" :placeholder="$t(`header.again`)" auto-complete="off">
        </el-input>
         <img @click="visible3 = !visible3" v-show="!visible3" class="eyes-image" src="@/assets/images/login/show.png" alt="">
          <img @click="visible3 = !visible3" v-show="visible3" class="eyes-image" src="@/assets/images/login/hidden.png" alt="">
      </el-form-item>
      <div class="tip"><img src="@/assets/images/manage/tip_icon.png"><span>{{$t(`header.tip`)}}</span></div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <v-btn @submitForm="submitForm" @cancel="cancel"></v-btn>
    </span>
  </el-dialog>
</template>
<script>
import validate from 'ZWSUtils/validate.js'
import ZlgCloudHelper from '@/native/zlgcloudhelper.js'
import VBtn from '@/components/User/Auth/Btn.vue'
export default {
  components: {
    VBtn
  },
  props: {
    fatherDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const checkPassword = (rule, value, callback) => {
      if (rule.field === 'newPassword' && value === this.passwordForm.password) {
        callback(new Error(this.$t(`userTips.password.repeat`)))
      }
      const result = validate.isPassword(value)
      callback(result ? undefined : new Error(this.$t('userTips.password.error')))
    }
    const checkConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t(`header.again`)))
      }
      const result = value === this.passwordForm.newPassword
      callback(result ? undefined : new Error(this.$t(`userTips.confirmPassword.error`)))
    }
    return {
      visible1: false,
      visible2: false,
      visible3: false,
      passwordForm: {
        newPassword: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        password: [
          { required: true, message: this.$t(`header.old`), trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t(`header.new`), trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          ZlgCloudHelper.changePassword({
            oldpassword: this.passwordForm.password,
            newpassword: this.passwordForm.newPassword
          }).then(res => {
            this.$router.push('/Login')
            localStorage.removeItem('zlg_label_userinfo')
            this.dialogVisible = false
          })
        }
      })
    },
    cancel () {
      this.$refs.passwordForm.resetFields()
      this.dialogVisible = false
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.fatherDialogVisible
      },
      set (val) {
        this.$emit('getResetPassword', val)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.el-form-item__content {
  position: relative;
  .eyes-image {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 8px;
  }
}
.tip {
  height: 22px;
  line-height: 22px;
  text-align: left;
  position: relative;
  padding-left: 100px;
  font-size: 12px;
  color: #8c9196;
  img {
    position: absolute;
    top: 2px;
    left: 76px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Auth/UpdatePassWord.vue